import { render, staticRenderFns } from "./familyMember.vue?vue&type=template&id=5a827705&scoped=true"
import script from "./familyMember.vue?vue&type=script&lang=js"
export * from "./familyMember.vue?vue&type=script&lang=js"
import style0 from "./familyMember.vue?vue&type=style&index=0&id=5a827705&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a827705",
  null
  
)

export default component.exports